import { render, staticRenderFns } from "./VolunteerWizard.vue?vue&type=template&id=08af4b8d&scoped=true&"
import script from "./VolunteerWizard.vue?vue&type=script&lang=js&"
export * from "./VolunteerWizard.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerWizard.vue?vue&type=style&index=0&id=08af4b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af4b8d",
  null
  
)

export default component.exports